import { render, staticRenderFns } from "./PageSEO.vue?vue&type=template&id=1f59af30&"
import script from "./PageSEO.vue?vue&type=script&lang=ts&"
export * from "./PageSEO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports